import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class EquipeService {

	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getEquipes(cliente, equipe_id) {
		let myHeaders = new Headers({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' });
		myHeaders.append('Accept', 'text/plain');
		myHeaders.append('Accept', ' application/xhtml+xml ');
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Cliente', cliente);
		myHeaders.append('Equipe', equipe_id);

		let options = new RequestOptions({ headers: myHeaders });
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/service/equipe', options)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getVeiculos(cliente) {
		let myHeaders = new Headers({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' });
		myHeaders.append('Accept', 'text/plain');
		myHeaders.append('Accept', ' application/xhtml+xml ');
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Cliente', cliente);

		let options = new RequestOptions({ headers: myHeaders });
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/service/veiculos', options)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getEquipesClienteUnidade(cliente_id, unidade_id, equipe_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/service/equipeClienteUnidade/'+ cliente_id + '/' + unidade_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});

	}	

	getEquipesPorVeiculo(veiculo_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/service/equipePorVeiculo/'+ veiculo_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});

	}	
	
	

}
